<script setup>
const props = defineProps({
	size: Number,
	score: {
		type: [String, Number],
		required: true,
		validator: (value) => {
			const isNumber = typeof value === 'number';
			const isStringNumber = typeof value === 'string' && !isNaN(Number(value));
			return isNumber || isStringNumber;
		},
	},
	// fillColor: String,
	// clearColor: String,
})
import OneStar from '@/components/stars/OneStar.vue'

function getStars(_score) {

	const array = []

	let score = _score

	for (let i = 0; i < 5; i++) {
		if (score < 0.5) {
			array.push(0)
		} else if (score < 1) {
			array.push(0.5)
		} else if (score >= 1) {
			array.push(1)
		}
		score--
	}
	return array
}

const array = getStars(props.score || 0)

</script>

<template>

	<div class="star_block">
		<OneStar :state="array[0]" :size="props.size || 26" />
		<OneStar :state="array[1]" :size="props.size || 26" />
		<OneStar :state="array[2]" :size="props.size || 26" />
		<OneStar :state="array[3]" :size="props.size || 26" />
		<OneStar :state="array[4]" :size="props.size || 26" />
	</div>

</template>

<style>
.star_block {
	/* padding: 10px 0; */
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: nowrap;
}
</style>
